import { InvoiceLineType } from '../enums/invoiceLineType'
import { InvoiceFormLine } from '../types/invoiceForm/invoiceFormLine/invoiceFormLine'
import { InvoiceFormRowLine } from '../types/invoiceForm/invoiceFormLine/invoiceFormRowLine'

export const isInvoiceFormRowLine = (line: InvoiceFormLine): line is InvoiceFormRowLine =>
  line.type === InvoiceLineType.Row
